import React, { useState, lazy } from 'react';
import { LegalModal } from './LegalModal';
type ModalType = 'privacy' | 'terms' | 'medical' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const year = new Date().getFullYear();
  return <footer className="border-t border-gold/20 bg-emerald py-12 px-4" data-id="element-21">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center gap-6" data-id="element-22">
        <div className="bg-white/95 rounded-xl px-5 py-3 shadow-sm border border-white/20" data-id="element-23">
          <img src="https://cdn.magicpatterns.com/uploads/exH9G2rgUuiMQFMLYuFBer/Captura_de_pantalla_2026-06-11_a_la(s)_11.21.26_a.m..png?w=400&q=85" alt="MinHealthGroup" width={200} height={50} loading="lazy" decoding="async" className="h-10 w-auto object-contain mix-blend-multiply" data-id="element-24" />
        </div>

        <nav aria-label="Enlaces legales" className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3" data-id="element-25">
          <button onClick={() => setActiveModal('privacy')} className="text-sm text-marble/80 hover:text-gold transition-colors focus:outline-none focus:text-gold" data-id="element-26">
            Política de Privacidad
          </button>
          <span className="text-emerald-light" aria-hidden="true" data-id="element-27">
            ·
          </span>
          <button onClick={() => setActiveModal('terms')} className="text-sm text-marble/80 hover:text-gold transition-colors focus:outline-none focus:text-gold" data-id="element-28">
            Términos de Servicio
          </button>
          <span className="text-emerald-light" aria-hidden="true" data-id="element-29">
            ·
          </span>
          <button onClick={() => setActiveModal('medical')} className="text-sm text-marble/80 hover:text-gold transition-colors focus:outline-none focus:text-gold" data-id="element-30">
            Descargo de Responsabilidad Médico
          </button>
        </nav>

        <p className="text-sm text-marble/60" data-id="element-31">
          © {year} MinHealthGroup. Todos los derechos reservados.
        </p>

        <p className="text-xs text-marble/40 max-w-xl leading-relaxed" data-id="element-32">
          Este producto es de carácter educativo y no constituye asesoramiento
          médico. Los resultados pueden variar según cada persona.
        </p>
      </div>

      {/* Privacy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" lastUpdated="12 de junio de 2026" data-id="element-33">
        <p data-id="element-34">
          En MinHealthGroup respetamos tu privacidad. Esta política describe
          cómo recopilamos, utilizamos y protegemos la información que nos
          proporcionas al utilizar nuestro sitio y adquirir nuestros productos.
        </p>
        <div data-id="element-35">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-36">
            1. Información que recopilamos
          </h3>
          <p data-id="element-37">
            Podemos recopilar datos que nos facilitas voluntariamente, como tu
            nombre y correo electrónico al realizar una compra, así como datos
            de navegación recogidos automáticamente (dirección IP, tipo de
            navegador y páginas visitadas).
          </p>
        </div>
        <div data-id="element-38">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-39">
            2. Uso de la información
          </h3>
          <p data-id="element-40">
            Utilizamos tus datos para procesar pedidos, entregar el acceso al
            producto digital, mejorar nuestros servicios y enviarte
            comunicaciones relacionadas con tu compra. Nunca venderemos tu
            información a terceros.
          </p>
        </div>
        <div data-id="element-41">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-42">
            3. Cookies
          </h3>
          <p data-id="element-43">
            Empleamos cookies y tecnologías similares para recordar tus
            preferencias y analizar el tráfico del sitio. Puedes configurar tu
            navegador para rechazar las cookies, aunque esto podría afectar a
            algunas funcionalidades.
          </p>
        </div>
        <div data-id="element-44">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-45">
            4. Seguridad de los datos
          </h3>
          <p data-id="element-46">
            Aplicamos medidas técnicas y organizativas razonables para proteger
            tu información frente a accesos no autorizados, pérdida o
            alteración.
          </p>
        </div>
        <div data-id="element-47">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-48">
            5. Tus derechos
          </h3>
          <p data-id="element-49">
            Tienes derecho a acceder, rectificar o solicitar la eliminación de
            tus datos personales, así como a oponerte a su tratamiento, conforme
            a la legislación vigente en materia de protección de datos.
          </p>
        </div>
        <div data-id="element-50">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-51">
            6. Cambios en esta política
          </h3>
          <p data-id="element-52">
            Nos reservamos el derecho de actualizar esta política en cualquier
            momento. Las modificaciones se publicarán en esta misma página con
            su fecha de actualización.
          </p>
        </div>
      </LegalModal>

      {/* Terms Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos de Servicio" lastUpdated="12 de junio de 2026" data-id="element-53">
        <p data-id="element-54">
          Al acceder y utilizar este sitio web y adquirir El Protocolo de
          Longevidad 45+, aceptas los siguientes términos y condiciones en su
          totalidad.
        </p>
        <div data-id="element-55">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-56">
            1. Aceptación de los términos
          </h3>
          <p data-id="element-57">
            El uso de este sitio implica la aceptación plena de estos términos.
            Si no estás de acuerdo con alguno de ellos, te pedimos que no
            utilices el sitio ni adquieras el producto.
          </p>
        </div>
        <div data-id="element-58">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-59">
            2. Uso del producto
          </h3>
          <p data-id="element-60">
            El producto se proporciona en formato digital para uso personal y no
            transferible. Queda prohibida su reproducción, distribución o
            reventa sin autorización expresa.
          </p>
        </div>
        <div data-id="element-61">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-62">
            3. Propiedad intelectual
          </h3>
          <p data-id="element-63">
            Todo el contenido, marcas, textos e imágenes son propiedad de
            MinHealthGroup y están protegidos por las leyes de propiedad
            intelectual aplicables.
          </p>
        </div>
        <div data-id="element-64">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-65">
            4. Descargo de responsabilidad sobre la salud
          </h3>
          <p data-id="element-66">
            La información ofrecida tiene fines exclusivamente educativos y no
            sustituye el consejo, diagnóstico ni tratamiento médico profesional.
            Los resultados pueden variar y no se garantizan. Consulta siempre a
            un profesional de la salud antes de iniciar cualquier protocolo,
            dieta o cambio de hábitos.
          </p>
        </div>
        <div data-id="element-67">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-68">
            5. Limitación de responsabilidad
          </h3>
          <p data-id="element-69">
            MinHealthGroup no será responsable de daños directos o indirectos
            derivados del uso o la imposibilidad de uso del producto o del sitio
            web.
          </p>
        </div>
        <div data-id="element-70">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-71">
            6. Ley aplicable
          </h3>
          <p data-id="element-72">
            Estos términos se rigen por la legislación aplicable en la
            jurisdicción donde opera MinHealthGroup. Cualquier controversia se
            someterá a los tribunales competentes de dicha jurisdicción.
          </p>
        </div>
      </LegalModal>

      {/* Medical Disclaimer Modal */}
      <LegalModal isOpen={activeModal === 'medical'} onClose={() => setActiveModal(null)} title="Descargo de Responsabilidad Médico" lastUpdated="12 de junio de 2026" data-id="element-73">
        <p data-id="element-74">
          La información proporcionada por MinHealthGroup, incluyendo pero no
          limitándose a textos, gráficos, imágenes y otros materiales contenidos
          en este sitio web y en nuestros productos digitales, tiene fines
          exclusivamente educativos e informativos.
        </p>
        <div data-id="element-75">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-76">
            1. No es consejo médico
          </h3>
          <p data-id="element-77">
            El contenido no pretende ser un sustituto del consejo, diagnóstico o
            tratamiento médico profesional. Siempre busca el consejo de tu
            médico u otro proveedor de salud calificado con cualquier pregunta
            que puedas tener respecto a una condición médica.
          </p>
        </div>
        <div data-id="element-78">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-79">
            2. Consulta profesional
          </h3>
          <p data-id="element-80">
            Nunca ignores el consejo médico profesional ni te demores en
            buscarlo debido a algo que hayas leído en este sitio web o en
            nuestros materiales. Antes de iniciar cualquier nuevo régimen de
            dieta, suplementación o ejercicio, consulta con un profesional de la
            salud.
          </p>
        </div>
        <div data-id="element-81">
          <h3 className="text-lg font-semibold text-emerald mb-2" data-id="element-82">
            3. Resultados individuales
          </h3>
          <p data-id="element-83">
            Los testimonios y ejemplos mostrados representan resultados
            excepcionales y no garantizan que cualquier persona logre los mismos
            o similares resultados. El éxito de cada individuo depende de sus
            antecedentes, dedicación, deseo y motivación.
          </p>
        </div>
      </LegalModal>
    </footer>;
}